export default class Page {
  constructor(name = "Nueva página", index) {
    this.index = index;
    this.name = name;
    this.created_at = new Date();
    this.updated_at = this.created_at;
    this.content = "";
    this.background = null;
  }
}
